/**
 * Tabs name in control center.
 */
export enum FacetName {
  COMMUNITIES = 'communities',
  WHATSNEW = 'whatsnew',
  REPORTABUSE = 'report-abuse',
  ADMINISTRATORS = 'administrators',
  MEDIA = 'media',
  ANALYTICS = 'analytics',
  SETTINGS = 'settings',
}

/**
 * Tabs number in control center.
 */
export enum FacetNumber {
  COMMUNITIES = 0,
  WHATSNEW = 1,
  REPORTABUSE = 2,
  ADMINISTRATORS = 3,
  MEDIA = 4,
  ANALYTICS = 5,
  SETTINGS = 6,
}
